export * from './customer.component';
